<template>
  <div class="app-container">
        <el-row :gutter="24" type="flex" justify="center" v-if="searchOpen">
          <el-col :sm="16" :sx="24">
            <search class="search" />
          </el-col>
        </el-row>
        <!-- 优选展示部分数据，提高用户体验 -->
        <div v-loading="loading" element-loading-text="数据加载中，请稍等...">
          <div v-for="categorySite in siteStartList" :key="categorySite.id">
            <h4
              :id="'category-' + categorySite.id"
              :ref="'category-' + categorySite.id"
            >
              <svg-icon icon-name="tag" class="client-category-icon" />
              <span class="client-category-name">{{
                categorySite.categoryName
              }}</span>
            </h4>
            <el-row :gutter="24">
              <el-col
                :sm="24 / showCount"
                :sx="24"
                class="mb15"
                v-for="site in categorySite.sites"
                :key="site.id"
              >
                <site-card :site="site" :disabled-tip="false" />
              </el-col>
            </el-row>
          </div>
        </div>
        <div
          style="height: 200px; width: 100%"
          v-if="otherLoading"
          v-loading="otherLoading"
          element-loading-text="当前网站数量较多，正在为您加载剩余网站数据..."
        ></div>
        <div v-else>
          <div v-for="categorySite in siteList" :key="categorySite.id">
            <h4
              :id="'category-' + categorySite.id"
              :ref="'category-' + categorySite.id"
            >
              <svg-icon icon-name="tag" class="client-category-icon" />
              <span class="client-category-name">{{
                categorySite.categoryName
              }}</span>
            </h4>
            <el-row :gutter="24">
              <el-col
                :sm="24 / showCount"
                :sx="24"
                class="mb15"
                v-for="site in categorySite.sites"
                :key="site.id"
              >
                <site-card :site="site" :disabled-tip="false" />
              </el-col>
            </el-row>
          </div>
        </div>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

import SiteCard from '@/components/SiteCard'
import Search from '@/layout/client/components/Search'

import { categorySiteList } from '@/api/client/nav'
import { add } from '@/api/nav/log/visit'
import { useClientCategories } from '@/composables/useClientCategories'

const store = useStore()
const setCategories = useClientCategories()

const searchOpen = computed(() => store.getters['settings/searchOpen'])
const showCount = computed(() => store.getters['settings/showCount'])

const loading = ref(true)
const otherLoading = ref(false)
const siteList = ref([])
const siteStartList = ref([])

/**
 * 获取数据
 */
async function getData() {
  loading.value = true
  const {
    data: { categories, sites }
  } = await categorySiteList()
  // 首页使用自身接口返回的系统分类填充左侧栏
  setCategories(categories)
  // 优先展示部分数据，以免数据太多，加载太慢
  if (sites.length > 3) {
    siteStartList.value.push(sites[0])
    siteStartList.value.push(sites[1])
    // 延时渲染数据，提高用户体验
    otherLoading.value = true
    setTimeout(() => {
      sites.splice(0, 2)
      siteList.value = sites
      otherLoading.value = false
    }, 500)
  } else {
    siteList.value = sites
  }
  loading.value = false
  // 记录导航访问记录
  add()
}

getData()
</script>
